export default __webpack_public_path__ + "static/framer1-5aa8771618bc55e285ba96ff815dda7a.jpg";